/* istanbul ignore file reason: ionic deploy provider issue */
import { Component, Inject, OnInit } from '@angular/core';
import { Deploy } from 'cordova-plugin-ionic/dist/ngx';
import { UpdateAppConfig } from 'src/app/update-app/update-app.service';

@Component({
  selector: 'app-live-update',
  templateUrl: './live-update.page.html',
  styleUrls: ['./live-update.page.scss'],
})
export class LiveUpdatePage implements OnInit {
  public progressPercent = 0;
  public version: string;

  constructor(private deploy: Deploy, @Inject(UpdateAppConfig) private config: UpdateAppConfig) {}

  ngOnInit() {
    this.updateApp();
  }

  async updateApp() {
    const liveUpdate = await this.startLiveUpdate();
    if (!liveUpdate.available) return;

    await this.watchLiveUpdate();
    await this.endLiveUpdate();
  }

  async startLiveUpdate() {
    await this.deploy.configure({ channel: this.config.deployChannel });
    return this.deploy.checkForUpdate();
  }

  async watchLiveUpdate() {
    await this.deploy.downloadUpdate(progress => {
      this.progressPercent = progress / 2; // Separates progress bar to two divisions
    });
    await this.deploy.extractUpdate(progress => {
      this.progressPercent = progress;
    });
  }

  async endLiveUpdate() {
    await this.deploy.reloadApp();
  }
}
